import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import {
  FiSearch,
  FiMapPin,
  FiX,
  FiCheck,
  FiSliders,
  FiUsers,
  FiShield,
  FiPhoneCall,
  FiAlertCircle,
  FiAward,
} from "react-icons/fi";
import Header from "../../components/layouts/Header";
import Footer from "../../components/layouts/Footer";
import { Baseurl } from "../../config/BaseUrl";
import { setleadesSearchObjects } from "../../redux/search/SearchSlice";
import { getSubCategory } from "../../redux/subCategory/SubCategorySlice";
import "./LeadToSearchNew.css";

const POPULAR_LOCALITIES = [
  "Hyderabad",
  "Gachibowli",
  "Madhapur",
  "Hitec City",
  "Kondapur",
  "Kokapet",
  "Tellapur",
  "Nallagandla",
  "Banjara Hills",
  "Jubilee Hills",
  "Manikonda",
  "Miyapur",
];

const FALLBACK_SUBCATS = {
  Residential_Sell: [
    { name: "Apartment" },
    { name: "Independent House" },
    { name: "Villa" },
    { name: "Plot" },
    { name: "Land" },
  ],
  Residential_Rent: [
    { name: "Apartment" },
    { name: "Independent House" },
    { name: "Villa" },
    { name: "Pg" },
  ],
  Commercial_Sell: [
    { name: "Commercial Office" },
    { name: "Commercial Shop" },
    { name: "Commercial Land" },
    { name: "Warehouse/Godown" },
  ],
  Commercial_Rent: [
    { name: "Commercial Office" },
    { name: "Commercial Shop" },
    { name: "Warehouse/Godown" },
  ],
};

const LeadToSearch = () => {
  const { subCatTotal } = useSelector((state) => state.SubCategory);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectSupcat, setselectSupcat] = useState("Residential");
  const [selectbuyrent, setselectbuyrent] = useState("Sell");
  const [showSubcat, setshowSubcat] = useState([]);
  const [selectedSubcat, setSelectedSubcat] = useState([]);
  const [selectedBedrooms, setSelectedBedrooms] = useState(["1", "2", "3"]);
  const [selectedMinValue, setSelectedMinValue] = useState("");
  const [selectedMaxvalue, setSelectedMaxValue] = useState("");
  const [search, setSearch] = useState("");
  const [searchArray, setSearchArray] = useState([]);

  const [propertySearch, setPropertySearch] = useState([]);
  const [propertySearchProject, setPropertySearchProject] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [validationModalOpen, setValidationModalOpen] = useState(false);

  const searchBoxRef = useRef(null);

  const budgetList = [
    { id: "1", name: "5 Lacs", budget: 500000 },
    { id: "2", name: "10 Lacs", budget: 1000000 },
    { id: "3", name: "15 Lacs", budget: 1500000 },
    { id: "4", name: "20 Lacs", budget: 2000000 },
    { id: "5", name: "25 Lacs", budget: 2500000 },
    { id: "6", name: "35 Lacs", budget: 3500000 },
    { id: "7", name: "40 Lacs", budget: 4000000 },
    { id: "8", name: "50 Lacs", budget: 5000000 },
    { id: "9", name: "60 Lacs", budget: 6000000 },
    { id: "10", name: "75 Lacs", budget: 7500000 },
    { id: "11", name: "90 Lacs", budget: 9000000 },
    { id: "12", name: "1 Crore", budget: 10000000 },
    { id: "13", name: "1.5 Crore", budget: 15000000 },
    { id: "14", name: "2 Crore", budget: 20000000 },
    { id: "15", name: "3 Crore", budget: 30000000 },
    { id: "16", name: "5 Crore+", budget: 50000000 },
  ];

  const bhkOptions = ["1", "2", "3", "4", "5", "6+"];

  // Fetch subcategories if not loaded
  useEffect(() => {
    if (!subCatTotal || subCatTotal.length === 0) {
      dispatch(getSubCategory());
    }
  }, [dispatch, subCatTotal]);

  // Close autocomplete when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Sync subcategories on category or type change
  useEffect(() => {
    const isCommercial = selectSupcat.toLowerCase().includes("comm");
    const superCatKey = isCommercial ? "Commercial" : "Residential";
    const cacheKey = `${superCatKey}_${selectbuyrent}`;

    let filtered = [];
    if (Array.isArray(subCatTotal) && subCatTotal.length > 0) {
      filtered = subCatTotal.filter((data) => {
        const itemSuper = (data.superCategory || "").toLowerCase();
        const itemCat = (data.category || "").toLowerCase();
        const matchesSuper = isCommercial ? itemSuper.includes("comm") : itemSuper.includes("resid");
        const matchesCat = itemCat === selectbuyrent.toLowerCase();
        return matchesSuper && matchesCat;
      });
    }

    if (filtered.length === 0 && FALLBACK_SUBCATS[cacheKey]) {
      filtered = FALLBACK_SUBCATS[cacheKey];
    }

    setshowSubcat(filtered);
    setSelectedSubcat(filtered.map((item) => item.name));
  }, [subCatTotal, selectSupcat, selectbuyrent]);

  // Live autocomplete search with API + local fallback
  useEffect(() => {
    let isCancelled = false;
    const term = search.trim().toLowerCase();

    if (term.length >= 2) {
      // Instant local matches for Hyderabad top areas
      const localMatches = POPULAR_LOCALITIES.filter((loc) =>
        loc.toLowerCase().includes(term)
      ).map((loc) => ({ locality: loc, city: "Hyderabad" }));
      setPropertySearch(localMatches);

      const fetchSuggestions = async () => {
        try {
          const locRes = await axios.get(
            `${Baseurl}/api/v1/property/allPropertylocalitycity/${search.trim()}`
          );
          if (!isCancelled && locRes.data?.success && Array.isArray(locRes.data.properties)) {
            const apiProps = locRes.data.properties.slice(0, 6);
            setPropertySearch((prev) => {
              const combined = [...prev, ...apiProps];
              const seen = new Set();
              return combined.filter((item) => {
                const key = (item.locality || item.apartment || "").toLowerCase();
                if (!key || seen.has(key)) return false;
                seen.add(key);
                return true;
              });
            });
          }
        } catch (err) {}

        try {
          const projRes = await axios.get(
            `${Baseurl}/api/v1/property/allPropertyproject/${search.trim()}`
          );
          if (!isCancelled && projRes.data?.success && Array.isArray(projRes.data.properties)) {
            setPropertySearchProject(projRes.data.properties.slice(0, 6));
          }
        } catch (err) {}

        if (!isCancelled) setShowResults(true);
      };

      fetchSuggestions();
      setShowResults(true);
    } else {
      setPropertySearch([]);
      setPropertySearchProject([]);
      setShowResults(false);
    }

    return () => {
      isCancelled = true;
    };
  }, [search]);

  // Add locality to selected chips
  const storeCityInarray = (name) => {
    if (!name) return;
    const trimmed = name.trim();
    if (!searchArray.includes(trimmed)) {
      setSearchArray([trimmed, ...searchArray]);
    }
    setSearch("");
    setShowResults(false);
  };

  // Remove locality chip
  const removesearch = (name) => {
    setSearchArray(searchArray.filter((item) => item !== name));
  };

  // Toggle subcategory selection
  const handleSubcatToggle = (name) => {
    if (selectedSubcat.includes(name)) {
      setSelectedSubcat(selectedSubcat.filter((item) => item !== name));
    } else {
      setSelectedSubcat([...selectedSubcat, name]);
    }
  };

  // Toggle bedroom selection
  const handleBhkToggle = (bhk) => {
    if (selectedBedrooms.includes(bhk)) {
      setSelectedBedrooms(selectedBedrooms.filter((item) => item !== bhk));
    } else {
      setSelectedBedrooms([...selectedBedrooms, bhk]);
    }
  };

  // Dispatch and navigate
  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();

    let finalSearchArray = [...searchArray];
    if (search.trim() && !finalSearchArray.includes(search.trim())) {
      finalSearchArray.push(search.trim());
      setSearchArray(finalSearchArray);
      setSearch("");
    }

    if (finalSearchArray.length === 0) {
      finalSearchArray = ["Hyderabad"];
      setSearchArray(finalSearchArray);
    }

    const leadesForm = {
      selectSupcat,
      selectbuyrent,
      selectedSubcat:
        selectedSubcat.length > 0
          ? selectedSubcat
          : showSubcat.map((item) => item.name),
      selectedBedrooms,
      selectedMaxvalue,
      selectedMinValue,
      searchArray: finalSearchArray,
    };

    dispatch(setleadesSearchObjects(leadesForm));
    try {
      localStorage.setItem("leadesSearchObjects", JSON.stringify(leadesForm));
    } catch (err) {}

    navigate("/leadtosearch-result");
  };

  return (
    <div className="mgh-leadsearch-page">
      <Header />

      <main className="mgh-leadsearch-container">
        {/* ================= Header Title Block ================= */}
        <div className="mgh-lms-header-row">
          <div className="mgh-lms-title-block">
            <h1>
              Search Verified <span>Buyer & Tenant Leads</span>
            </h1>
            <p>
              Connect directly with genuine property seekers matching your listings across top localities.
            </p>
          </div>

          <div className="mgh-lms-credits-badge">
            <div>
              <div className="mgh-lms-credits-label">Credit Balance</div>
              <div className="mgh-lms-credits-val">0 / 0 Leads</div>
            </div>
            <Link
              to="/BossPlans"
              style={{
                marginLeft: "8px",
                padding: "6px 12px",
                background: "#ea580c",
                color: "#ffffff",
                borderRadius: "8px",
                fontSize: "12px",
                fontWeight: "700",
                textDecoration: "none",
              }}
            >
              Get Credits
            </Link>
          </div>
        </div>

        {/* ================= Search Filter Card ================= */}
        <div className="mgh-lms-search-card">
          {/* Controls: Segmented Category & Buy/Rent Switcher */}
          <div className="mgh-lms-controls-row">
            <div className="mgh-lms-segmented-group">
              <button
                type="button"
                className={`mgh-lms-seg-btn ${
                  selectSupcat === "Residential" ? "active" : ""
                }`}
                onClick={() => setselectSupcat("Residential")}
              >
                Residential
              </button>
              <button
                type="button"
                className={`mgh-lms-seg-btn ${
                  selectSupcat === "Commertial" ? "active" : ""
                }`}
                onClick={() => setselectSupcat("Commertial")}
              >
                Commercial
              </button>
            </div>

            <div className="mgh-lms-radio-pills">
              <label
                className={`mgh-lms-radio-pill ${
                  selectbuyrent === "Sell" ? "active" : ""
                }`}
                onClick={() => setselectbuyrent("Sell")}
              >
                <input
                  type="radio"
                  name="buyrent"
                  value="Sell"
                  checked={selectbuyrent === "Sell"}
                  onChange={() => setselectbuyrent("Sell")}
                />
                <span>Buy Leads</span>
              </label>

              <label
                className={`mgh-lms-radio-pill ${
                  selectbuyrent === "Rent" ? "active" : ""
                }`}
                onClick={() => setselectbuyrent("Rent")}
              >
                <input
                  type="radio"
                  name="buyrent"
                  value="Rent"
                  checked={selectbuyrent === "Rent"}
                  onChange={() => setselectbuyrent("Rent")}
                />
                <span>Rent Leads</span>
              </label>
            </div>
          </div>

          {/* Locality Autocomplete Search Field */}
          <div className="mgh-lms-locality-wrap" ref={searchBoxRef}>
            <div className="mgh-lms-input-box">
              <FiMapPin className="mgh-lms-input-icon" />
              <input
                type="text"
                className="mgh-lms-input-field"
                placeholder="Type Locality, Society, or Landmark (e.g. Madhapur, Gachibowli, Hitec City)..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    if (search.trim()) {
                      storeCityInarray(search.trim());
                    } else {
                      handleSearchSubmit(e);
                    }
                  }
                }}
                onFocus={() => {
                  if (search.length >= 2 || true) setShowResults(true);
                }}
              />
              {search && (
                <FiX
                  style={{ cursor: "pointer", color: "#94a3b8" }}
                  onClick={() => setSearch("")}
                />
              )}
            </div>

            {/* Quick Popular Localities Chips */}
            <div className="mgh-lms-quick-localities">
              <span className="mgh-lms-quick-label">Popular Localities:</span>
              {POPULAR_LOCALITIES.slice(0, 8).map((loc) => (
                <button
                  key={loc}
                  type="button"
                  className={`mgh-lms-quick-chip ${
                    searchArray.includes(loc) ? "selected" : ""
                  }`}
                  onClick={() => storeCityInarray(loc)}
                >
                  {searchArray.includes(loc) ? "✓" : "+"} {loc}
                </button>
              ))}
            </div>

            {/* Selected Chips */}
            {searchArray.length > 0 && (
              <div className="mgh-lms-selected-tags">
                {searchArray.map((item, idx) => (
                  <div key={idx} className="mgh-lms-tag">
                    <FiMapPin size={12} />
                    <span>{item}</span>
                    <FiX
                      className="mgh-lms-tag-remove"
                      onClick={() => removesearch(item)}
                    />
                  </div>
                ))}
              </div>
            )}

            {/* Suggestions Dropdown */}
            {showResults && (
              <div className="mgh-lms-suggestions-dropdown">
                {propertySearch.map((loc, idx) => {
                  const label = `${loc.locality}${loc.city ? ", " + loc.city : ""}`;
                  return (
                    <div
                      key={`loc-${idx}`}
                      className="mgh-lms-suggestion-item"
                      onClick={() => storeCityInarray(loc.locality)}
                    >
                      <FiMapPin style={{ color: "#ea580c" }} />
                      <span style={{ flex: 1, fontWeight: "600" }}>{label}</span>
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#94a3b8",
                          background: "#f1f5f9",
                          padding: "2px 6px",
                          borderRadius: "4px",
                        }}
                      >
                        Locality
                      </span>
                    </div>
                  );
                })}

                {propertySearchProject.map((proj, idx) => (
                  <div
                    key={`proj-${idx}`}
                    className="mgh-lms-suggestion-item"
                    onClick={() => storeCityInarray(proj.apartment)}
                  >
                    <FiMapPin style={{ color: "#ea580c" }} />
                    <span style={{ flex: 1, fontWeight: "600" }}>
                      {proj.apartment}
                    </span>
                    <span
                      style={{
                        fontSize: "11px",
                        color: "#94a3b8",
                        background: "#f1f5f9",
                        padding: "2px 6px",
                        borderRadius: "4px",
                      }}
                    >
                      Project
                    </span>
                  </div>
                ))}

                {search.trim() && (
                  <div
                    style={{
                      padding: "10px 16px",
                      color: "#ea580c",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: "pointer",
                      background: "#fff7ed",
                      borderTop: "1px solid #fed7aa",
                    }}
                    onClick={() => storeCityInarray(search.trim())}
                  >
                    + Add "<strong>{search.trim()}</strong>" as search location
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Subcategories Selector */}
          {showSubcat.length > 0 && (
            <div className="mgh-lms-field-wrap">
              <label className="mgh-lms-label">Property Sub-Types</label>
              <div className="mgh-lms-chips-row">
                {showSubcat.map((sub, idx) => {
                  const isChecked = selectedSubcat.includes(sub.name);
                  return (
                    <button
                      key={idx}
                      type="button"
                      className={`mgh-lms-chip ${isChecked ? "active" : ""}`}
                      onClick={() => handleSubcatToggle(sub.name)}
                    >
                      {isChecked && <FiCheck size={14} />}
                      <span>{sub.name}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* Bedrooms Selector (Residential only) */}
          {selectSupcat === "Residential" && (
            <div className="mgh-lms-field-wrap">
              <label className="mgh-lms-label">Bedrooms (BHK)</label>
              <div className="mgh-lms-bhk-row">
                {bhkOptions.map((bhk, idx) => {
                  const isChecked = selectedBedrooms.includes(bhk);
                  return (
                    <button
                      key={idx}
                      type="button"
                      className={`mgh-lms-bhk-chip ${isChecked ? "active" : ""}`}
                      onClick={() => handleBhkToggle(bhk)}
                    >
                      {bhk} BHK
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* Price Range Filters */}
          <div className="mgh-lms-filters-grid">
            <div className="mgh-lms-field-wrap">
              <label className="mgh-lms-label">Min Budget</label>
              <select
                className="mgh-lms-select"
                value={selectedMinValue ? selectedMinValue.id : ""}
                onChange={(e) => {
                  const val = budgetList.find((b) => b.id === e.target.value);
                  setSelectedMinValue(val || "");
                }}
              >
                <option value="">Any Min Price</option>
                {budgetList.map((item) => (
                  <option key={item.id} value={item.id}>
                    ₹ {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mgh-lms-field-wrap">
              <label className="mgh-lms-label">Max Budget</label>
              <select
                className="mgh-lms-select"
                value={selectedMaxvalue ? selectedMaxvalue.id : ""}
                onChange={(e) => {
                  const val = budgetList.find((b) => b.id === e.target.value);
                  setSelectedMaxValue(val || "");
                }}
              >
                <option value="">Any Max Price</option>
                {budgetList.map((item) => (
                  <option key={item.id} value={item.id}>
                    ₹ {item.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Submit Search Button */}
          <button
            type="button"
            className="mgh-lms-submit-btn"
            onClick={handleSearchSubmit}
          >
            <FiSearch size={18} />
            <span>Search Matching Leads</span>
          </button>
        </div>

        {/* ================= Trust & Value Cards ================= */}
        <div className="mgh-lms-benefits-grid">
          <div className="mgh-lms-benefit-card">
            <div className="mgh-lms-benefit-icon">
              <FiPhoneCall />
            </div>
            <div className="mgh-lms-benefit-info">
              <h4>Direct Phone Numbers</h4>
              <p>Instant access to verified contact numbers and direct WhatsApp buyer chats.</p>
            </div>
          </div>

          <div className="mgh-lms-benefit-card">
            <div className="mgh-lms-benefit-icon">
              <FiShield />
            </div>
            <div className="mgh-lms-benefit-info">
              <h4>100% Genuine Leads</h4>
              <p>Filter by real buyers with verified budgets actively searching in your locality.</p>
            </div>
          </div>

          <div className="mgh-lms-benefit-card">
            <div className="mgh-lms-benefit-icon">
              <FiUsers />
            </div>
            <div className="mgh-lms-benefit-info">
              <h4>High Conversion</h4>
              <p>Target tailored inquiries matched specifically to your property size and price.</p>
            </div>
          </div>
        </div>
      </main>

      {/* ================= Locality Validation Dialog ================= */}
      {validationModalOpen && (
        <div
          className="mgh-lms-modal-overlay"
          onClick={() => setValidationModalOpen(false)}
        >
          <div
            className="mgh-lms-modal-card"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mgh-lms-modal-icon">
              <FiAlertCircle />
            </div>
            <h3 className="mgh-lms-modal-title">Select a Locality</h3>
            <p className="mgh-lms-modal-text">
              Please enter and select at least one locality, city, or project to find matching buyer leads.
            </p>
            <button
              type="button"
              className="mgh-lms-modal-btn"
              onClick={() => setValidationModalOpen(false)}
            >
              Got it
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default LeadToSearch;
